/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import StringResources from 'nls/StringResources';


/**
* Helper class to encapsulate logic around getting data for the individual visualization stats
* (the middle 2 columns)
*/
export default class ChartDetail {
	constructor(props) {
		this.process(props);
	}

	process(props) {
		const { widgetId, widgetAlias, measureList } = props.widgetInfo;
		let { measureName } = props.widgetInfo;
		const summaryModel = props.summaryModel;
		const getChartSummaryStats = props.getChartSummaryStats;
		const getChartSubHeader = props.getChartSubHeader;

		measureName = summaryModel.getSelectedMeasureName(widgetId) || measureName;
		const statsInfo = getChartSummaryStats(widgetId, measureName);

		const list = [];
		measureList && measureList.forEach( (e) => {
			const label = StringResources.get('compareTable_ChartMeasureHeader', { name: widgetAlias, measure: e.metadata.label });
			list.push({ value:e.measureName, label: label } );
		});

		const onChange = (measureName) => {
			summaryModel.recomputeSummaryInfo({ widgetId, measureName });
		};

		this.cellRenderer = (row) =>{
			return summaryModel.getData(row, statsInfo);
		};
		this.headerRenderer = () => {
			const type = 'ChartDetail';
			const selected = measureName;
			const subHeader = getChartSubHeader(widgetId, measureName);
			return { type, selected, list, subHeader, onChange } ;
		};
	}
}



// WEBPACK FOOTER //
// ./src/js/components/lwstats/ChartDetail.js